import { ShoppingBag } from "lucide-react";

const PARTS = [
  { key: "processing", label: "In behandeling" },
  { key: "on-hold", label: "In de wacht" },
  { key: "pending", label: "Wacht op betaling" },
];

export function WebshopOrdersStrip({ webshop }) {
  if (!webshop.live) return null;
  const orders = webshop.open_orders || {};
  return (
    <div className="mt-6 surface p-5 md:p-6 flex flex-col md:flex-row md:items-center gap-4 md:gap-8" data-testid="webshop-orders-strip">
      <div className="flex items-center gap-3">
        <div className="p-2.5 rounded-md bg-primary/10 text-primary"><ShoppingBag className="w-5 h-5" /></div>
        <div>
          <div className="label-eyebrow">Open webshop-bestellingen</div>
          <div className="font-mono text-3xl font-semibold" data-testid="webshop-orders-total-dashboard">{webshop.open_orders_total ?? 0}</div>
        </div>
      </div>
      <div className="flex flex-wrap gap-3 md:ml-auto">
        {PARTS.map((p) => (
          <div key={p.key} className="px-4 py-2 rounded-md border border-border bg-muted/30" data-testid={`webshop-orders-${p.key}`}>
            <span className="text-sm text-muted-foreground">{p.label}</span>
            <span className="ml-2 font-mono font-semibold">{orders[p.key] ?? 0}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
